<template>
    <div id="About">
        <div class="content">
            <div v-if="weChatImg" class="left-content">
                <img :src="require('../../assets/img/'+weChatImg)" />
            </div>
            <div class="right-content">
                <div class="comname">{{comname}}</div>
                <div v-if="address" class="address">{{address}}</div>
                <div v-if="tel" class="tel"><label class="fa fa-phone" style="width:16px;"></label> {{tel}}</div>
                <div v-if="email" class=" email"><label class="fa fa-envelope-o"></label> {{email}}</div>
                <div v-if="weblink" class=" email">
                    <label class="fa fa-unlink"></label> 
                        <a v-bind:href="weblink" class="email" target="_blank">{{webInfo}}</a>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
export default {
    name: 'About',
    data () {
        return {
            // comname:"金米云（深圳）技术有限公司",
            // address:"深圳市福田区福保街道福保社区市花路南侧长富金茂大厦2号楼1115",
            // tel:"13510380804",
            // email:"tina@aurice.com"
        }
    },
    created () {
        if(this.configData){
            this.weChatImg=this.configData.weChatImg;
            this.comname=this.configData.comName;
            this.address=this.configData.address;
            this.tel=this.configData.tel;
            this.email=this.configData.email;
            this.weblink=this.configData.weblink;
            this.webInfo=this.configData.webInfo
        }
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
    #About{
        position:relative;
        top:80px;
        padding:50px 0;

    }
    .content{
        display: flex;
        margin: 0 5%;
        .left-content{
            text-align:center;
            flex:1;
            img {
                width:300px;
                height:300px;
            }
        }
        .right-content{
            flex:1;
            .comname{
                font-size:20px;
                margin-top:0;
                padding-bottom:5px;
            }
            div {
                font-size:16px;
                margin-top:18px;
            }
            .email{
                color:#FCC72C;
            }
            .tel{
                color:#FCC72C;
            }
        }
    }
</style>